export enum SelectInputType {
  Icon = 'icon',
  Other = 'other',
}

export class SelectOption<T> {
  text: string;
  value: T;
  disabled?: boolean;
  selected?: boolean;

  constructor(text: string, value: T, selected?: boolean, active?: boolean) {
    this.text = text;
    this.value = value;
    if (typeof selected === 'boolean') {
      this.selected = selected;
    }
    if (typeof active === 'boolean') {
      this.disabled = active;
    }
  }
}
